import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-message',
		defaultMessage:
			"We're having some trouble getting all available gadgets, please try again later",
		description: 'Error message informing the user that showing a list of available gadgets failed',
	},
	errorTitle: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-title',
		defaultMessage: 'Error',
		description:
			'Error message title informing the user that showing a list of available gadgets failed',
	},
	emptyTitle: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-title',
		defaultMessage: 'We couldn’t find any gadgets.',
		description: 'Label to indicate that no gadget can be found',
	},

	emptyMessage: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-message',
		defaultMessage: 'No gadgets matched your search. Try again with different keywords.',
		description: 'Text to indicate that no gadget can be found',
	},
});
